import { getProperty } from './getProperty';

export function doesPass(opening, property, value, exact) {
  var openingProperty = getProperty(opening, property);
  var valueString = value.toSearchString();
  if (valueString == null || !valueString.length) return false;
  if (valueString == '_') return openingProperty == null || (openingProperty && !openingProperty.toString().length);
  if (valueString == '*') return openingProperty != null && openingProperty.toString().length;
  if (valueString.startsWith('*') && valueString.endsWith('*'))
    return (
      openingProperty != null &&
      openingProperty
        .toString()
        .toSearchString()
        .includes(valueString.toSearchString(['\\*']))
    );
  if (valueString.startsWith('*'))
    return (
      openingProperty != null &&
      openingProperty
        .toString()
        .toSearchString()
        .endsWith(valueString.toSearchString(['\\*']))
    );
  if (valueString.endsWith('*'))
    return (
      openingProperty != null &&
      openingProperty
        .toString()
        .toSearchString()
        .startsWith(valueString.toSearchString(['\\*']))
    );
  if (valueString.startsWith('!')) {
    return (
      openingProperty != null &&
      (valueString.startsWith('!=')
        ? openingProperty.toString().toSearchString() != valueString.toSearchString(['!', '='])
        : !openingProperty
            .toString()
            .toSearchString()
            .includes(valueString.toSearchString(['!'])))
    );
  }
  return (
    openingProperty != null &&
    (exact
      ? openingProperty.toString().toSearchString() == valueString.toSearchString(['='])
      : openingProperty.toString().toSearchString().includes(valueString))
  );
}
